<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete infrastrukturu:</p>
      <p class="filename">{{ infrastructure.name }}</p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="deleteInfrastructure"
        :disabled="loading"
      >
        <span v-if="!loading">Potvrdi</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('table', ['infrastructure']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'removeInfrastructure']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getAllInfrastructure']),
    deleteInfrastructure() {
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      const data = {
        memberId: this.$store.getters.getActiveCommunity.member_id
      };
      axios
        .delete(`infrastructure/${this.infrastructure.id}`, {
          data: data
        })
        .then(async () => {
          if (
            this.$router.history.current.name ==
            'communityInfrastructureDetails'
          ) {
            this.$router.push({
              name: 'communityInfrastructure',
              params: {
                id: this.$store.getters.getActiveCommunity.id
              }
            });
          } else {
            await this.getAllInfrastructure({
              communityId: this.$store.getters.getActiveCommunity.community_id,
              infraTypes: this.$store.state.modal.infrastructureCategories
            });
          }

          this.loadingFinished();
          this.removeInfrastructure();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(e => {
          console.log('eer', e);
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped>
.filename {
  word-break: break-word;
}
</style>
